/* globals ALKMaps */
const debug = require("debug")("compliance:deriveroute");
import { getRoutePings, routingProfileProps, removeEmptyProp, getMercPoints } from "./compliance.helpers";

/**
   * @param {array} latLonArray latlong ie. [ [0,0], [1,1] ]
   * @param {object} routingProfile profile
   * @param {int} tripId id
   * @param {string} tripType 0 for planned, 1 for actual
   * @param {object} deps hash of dependencies
   * @returns {Promise} deferred value
**/
export function deriveRoute(latLonArray, routingProfile, tripId, tripType, deps) {
  const {$q, cacheService, ComplianceRoutingProfileService, UserProvider, mapUtilities} = deps;

  const deferred = $q.defer();
  if (!latLonArray || latLonArray.length === 0) {
    deferred.resolve([]);
    return deferred.promise;
  }

  const profileName = routingProfile ? routingProfile.name : "--";
  const tripCacheKey = `${tripId}_${profileName}_${(tripType === 0 ? "planned" : "actual")}`;
  //Fetch from cache if exists
  const cachedRoutePoints = cacheService.getCachedRoutePoints(tripCacheKey, routingProfile);
  if (cachedRoutePoints) {
    deferred.resolve(cachedRoutePoints);
    return deferred.promise;
  }
  const offRouteMiles = 0.03; // Always use 0.03 to account for small variations in Data Versions
  //Show the aligned route
  const request = ComplianceRoutingProfileService.getDerivedRouteRequest(latLonArray, routingProfile, offRouteMiles);
  debug("getDerivedRouteRequest() -> request:", request);

  ALKMaps.Services.postDerivedRoutePath({
    request: request,
    dataset: UserProvider.getUser().dataVersion,
    success: function (results) {
      if (!results) {
        deferred.resolve([]);
        return;
      }
      const mercPoints = getMercPoints(results, mapUtilities);
      //Cache using tripId and routingProfile.routingProfileId
      cacheService.setCachedRoutePoints(tripCacheKey, routingProfile, mercPoints);
      deferred.resolve(mercPoints);
    },
    failure: function (error) {
      debug("ALKMaps.Services.postDerivedRoutePath() >> error:", error, latLonArray);
      deferred.reject(error);
    }
  });

  return deferred.promise;
}

export function buildDerivedRouteRequest({ region, routingProfile, latLonArray, offRouteMiles, weight, isMetric}) {
  // https://developer.dev.trimblemaps.com/restful-apis/routing/post-route-reports/
  // refer to Libraries\ALK.Common.Model\RoutingProfiles\RoutingProfile.cs
  const request = {
    "RoutePings": getRoutePings(latLonArray),
    "OffRouteMiles": offRouteMiles,
    "HighwayOnly": routingProfile.highwayOnly || false,
    "ReportType": null,
    "Region": region,
    "RoutingOptions": {
      "VehicleType": routingProfileProps.vehicleTypes[routingProfile.vehicleType],
      "RoutingType": routingProfileProps.routingTypes[routingProfile.routingType],
      "HighwayOnly": routingProfile.highwayOnly || false,
      "UseAvoidsAndFavors": routingProfile.useAvoidFavors,
      "ClassOverrides": routingProfile.classOverrides,
      "DistanceUnits": routingProfileProps.distanceUnits[routingProfile.distanceUnits],
      "TollDiscourage": routingProfile.tollDiscouraged || false,
      "BordersOpen": routingProfile.bordersOpen,
      "OverrideRestrict": routingProfile.overrideRestrictions,
      "HazMatType": routingProfileProps.hazmatTypes[routingProfile.hazmatType],
      "RouteOptimization": null,
      "TruckCfg": {
        "Weight": weight,
        "Axles": routingProfile.numAxles < 2 ? null : routingProfile.numAxles,
        "Units": routingProfileProps.unitTypes[routingProfile.unitsOfMeasure],
        "LCV": routingProfile.lcv,
        "Width": routingProfile.maxWidth ? routingProfile.maxWidth + (isMetric ? "" : "\"") : null,
        "Height": routingProfile.maxHeight ? routingProfile.maxHeight + (isMetric ? "" : "\"") : null,
        "Length": routingProfile.totalLength ? routingProfile.totalLength + (isMetric ? "" : "\"") : null,
      },
      "HubRouting": routingProfile.hubRouting,
      "AFSetIDs": null,
      "ElevLimit": routingProfile.elevationLimit,
      "FerryDiscourage": routingProfile.isFerryDiscouraged,
      "GovernorSpeedLimit": routingProfile.governorSpeedLimit,
      "sideOfStreetAdherence": routingProfile.sideOfStreetAdherence,
      "useSites": routingProfile.useSites,
      "useTraffic": routingProfile.useTraffic,
    }
  };

  // This is needed so the PCM derivedRoute/routePath service call doesn't return 400
  request.RoutingOptions = removeEmptyProp(request.RoutingOptions);
  return request;
}



// WEBPACK FOOTER //
// ./app/compliance/deriveRoute.js